export function objectToFormData(obj: Record<string, unknown>): FormData {
  const formData = new FormData();

  Object.keys(obj).forEach((key) => {
    const value = obj[key];

    if (value === null || value === undefined) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => {
        formData.append(`${key}`, String(item));
      });
    } else {
      formData.append(key, value as string | Blob);
    }
  });

  return formData;
}
